import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="w-full min-h-screen bg-navy-900" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MechanismSection data-id="element-3" />
      <WhatYouGetSection data-id="element-4" />
      <WhoIsForSection data-id="element-5" />
      <HowItWorksSection data-id="element-6" />
      <ProofSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <FooterSection data-id="element-10" />
    </div>;
}